__turbopack_context__.v({
  "buttonsWrapper": "olTYEW_buttonsWrapper",
  "editOrderDescriptionWrapper": "olTYEW_editOrderDescriptionWrapper",
  "listItemDescription": "olTYEW_listItemDescription",
  "listItemTitle": "olTYEW_listItemTitle",
  "listItemWrapper": "olTYEW_listItemWrapper",
  "listWrapper": "olTYEW_listWrapper",
});
